<template>
  <div>
    <div
        v-if="isLoading"
        id="loading-bg__cus"
        class="fs-loading__cus"
        style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
      "
    ></div>
    <b-row>
      <b-col class="mb-2 d-flex justify-content-center pyc-header" cols="12">
        {{ detailData && detailData.name }}
      </b-col>
    </b-row>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label class="col-form-label"
              >Mức độ khẩn cấp<span class="text-danger"> *</span></label
              >
              <Select2
                  v-model="isUrgent"
                  :class="blur && !isUrgent ? `select2-error` : ''"
                  :options="urgentSelectData"
                  placeholder="Mức độ khẩn cấp"
              />
              <label
                  v-if="blur && !isUrgent"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn mức độ khẩn cấp</label
              >
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label class="col-form-label"
              >Loại<span class="text-danger"> *</span></label
              >
              <Select2
                  v-model="type"
                  :class="blur && !type ? `select2-error` : ''"
                  :options="requestTypeSelectData"
                  placeholder="Loại"
              />
              <label
                  v-if="blur && !type"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn loại</label
              >
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label class="col-form-label"
              >Sản phẩm<span class="text-danger"> *</span></label
              >
              <Select2
                  v-model="campType"
                  :class="blur && !campType ? `select2-error` : ''"
                  :options="dropListSelectData"
                  placeholder="Sản phẩm"
              />
              <label
                  v-if="blur && !campType"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Vui lòng chọn sản phẩm</label
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label class="col-form-label"
              >Thời gian bắt đầu<span class="text-danger"> *</span></label
              >
              <b-form-datepicker
                  v-model="startDate"
                  :class="blur && isValidDate ? 'error' : ''"
                  :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                  locale="vi-VN"
                  placeholder="dd/mm/yyyy"
              />
              <label
                  v-if="blur && isValidDate"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Thời gian bắt đầu không vượt quá thời gian kết thúc</label
              >
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label class="col-form-label"
              >Thời gian kết thúc<span class="text-danger"> *</span></label
              >
              <b-form-datepicker
                  v-model="endDate"
                  :class="blur && isValidDate ? 'error' : ''"
                  :date-format-options="{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }"
                  locale="vi-VN"
                  placeholder="dd/mm/yyyy"
              />
              <label
                  v-if="blur && isValidDate"
                  class="col-form-label text-danger"
                  style="padding-bottom: 0"
              >Thời gian kết thúc không nhỏ hơn thời gian bắt đầu</label
              >
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <div
            v-for="(item, index) in templates"
            v-if="templates.length > 0 && isShow(index)"
            :key="index"
        >
          <div class="title-id">Mẫu số {{ noOfTemplate(index) }}</div>
          <model-form
              :ref="`editModelFormRef${index}`"
              :index="index"
              :isAddTemplateBtn="index == indexAddTemplateBtn"
              :pycType="type"
              @onAddTemplateClick="addNewTemplate"
              @onDelete="onDeleteRow"
          />
          <div v-if="index != indexAddTemplateBtn" class="break-line"></div>
        </div>
        <b-row v-if="templates.length === 0">
          <b-col class="no-data" cols="12"> No data</b-col>
          <b-col class="text-align-right" cols="12">
            <b-button
                class="btn-icon"
                style="margin-left: 10px"
                variant="danger"
                @click="addNewTemplate"
            >
              <feather-icon icon="PlusIcon"/>
              Thêm mẫu tin
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-row>
      <b-col class="text-align-right" cols="12">
        <b-button class="btn-icon p-inline-30" variant="danger" @click="onSaveData"
        >Lưu
        </b-button
        >
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {BButton, BCard, BCol, BFormDatepicker, BFormGroup, BRow} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ModelForm from "../modelForm/modelForm.vue";
import Select2 from "v-select2-component";
import moment from "moment";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    ModelForm,
    Select2,
    BFormDatepicker,
    BFormGroup,
  },
  props: {
    pycType: {
      type: String,
      default: "",
    },
  },
  async mounted() {
    this.detaiId = this.$route.params.id;
    await this.getInitDropdownData();
    this.getDetailData(this.detaiId);
  },
  computed: {
    isValidDate() {
      const start = moment(this.startDate);
      const end = moment(this.endDate);

      return end.isBefore(start);
    },
  },
  watch: {
    templates: {
      immediate: true,
      handler(val, oldVal) {
        this.getIndexAddTemplateBtn();
      },
    },
    posRemoveTemplate: {
      immediate: true,
      handler(val, oldVal) {
        this.getIndexAddTemplateBtn();
      },
    },
  },
  methods: {
    async getInitDropdownData() {
      const urgentData = await useJwt.get("isUrgent");
      if (urgentData.data && urgentData.data.result) {
        this.urgentSelectData = urgentData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const requestTypeData = await useJwt.get("requestType");
      if (requestTypeData.data && requestTypeData.data.result) {
        this.requestTypeSelectData = requestTypeData.data.result.map((item) => ({
          id: item.id,
          text: item.value,
        }));
      }

      const dropListData = await useJwt.get("dropListServices");
      if (dropListData.data && dropListData.data.result) {
        this.dropListSelectData = dropListData.data.result.map((item) => ({
          id: item.id,
          text: item.name,
        }));
      }
    },
    isShow(index) {
      return this.posRemoveTemplate.filter((item) => item == index).length == 0;
    },
    getIndexAddTemplateBtn() {
      for (let i = this.templates.length - 1; i >= 0; i--) {
        const isAdd = this.posRemoveTemplate.filter((idx) => idx == i).length == 0;
        if (isAdd) {
          this.indexAddTemplateBtn = i;
          return;
        }
      }
    },
    noOfTemplate(index) {
      let num = index;

      for (const i in this.posRemoveTemplate) {
        if (index > this.posRemoveTemplate[i]) {
          num--;
        }
      }

      return num + 1;
    },
    async onSaveData() {
      const validate =
          !!this.type &&
          !!this.isUrgent &&
          !!this.campType &&
          !!this.endDate &&
          !!this.startDate &&
          !this.isValidDate;

      const notifyList = [];

      let isError = false;

      for (const i in this.templates) {
        if (!this.isShow(+i)) {
          continue;
        }

        const item = this.detailData.listNotify[i];

        const ref = this.$refs[`editModelFormRef${i}`][0];
        if (ref) {
          const data = ref.getData();
          if (data) {
            if (item && item.id) {
              data.id = item.id;
            }
            notifyList.push(data);
          } else {
            isError = true;
          }
        }
      }

      if (isError || !validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        this.blur = true;
        return;
      }

      this.blur = false;

      const updateData = {
        id: this.detailData.id,
        campType: this.campType,
        endDate: this.endDate,
        isUrgent: this.isUrgent,
        notifyList: notifyList,
        startDate: this.startDate,
        type: this.type,
      };

      this.isLoading = true;

      const rs = await useJwt.post(`update_camp`, updateData);
      if (rs.data.code === 200) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: rs.data.message,
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });

        setTimeout(() => {
          this.$router.push("/noti-request/home");
        }, 300);
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: rs.data.message,
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
      this.isLoading = false;
    },
    async onDeleteRow(index) {
      const item = this.detailData.listNotify.find((item, idx) => idx == index);
      if (item) {
        const rs = await useJwt.get(`delete_notify/${item.id}`);
        if (rs.data.code === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: rs.data.message,
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: rs.data.message,
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      }

      this.posRemoveTemplate.push(index);
    },
    addNewTemplate() {
      this.templates.push("a");
    },
    async getDetailData(id) {
      const response = await useJwt.get(`CampDetail/${id}`);
      if (response.data.code === 200) {
        this.detailData = JSON.parse(JSON.stringify(response.data.result));

        this.type = this.detailData.type;
        this.isUrgent = this.detailData.isUrgent;
        this.campType = this.detailData.campaignType;
        this.endDate = moment(this.detailData.endDate, "DD-MM-yyyy").format("yyyy-MM-DD");
        this.startDate = moment(this.detailData.startDate, "DD-MM-yyyy").format(
            "yyyy-MM-DD"
        );

        if (this.detailData && this.detailData.listNotify != null) {
          this.templates = this.detailData.listNotify.map((i) => "a");
          setTimeout(() => {
            for (const i in this.detailData.listNotify) {
              const ref = this.$refs[`editModelFormRef${i}`][0];
              if (ref) {
                ref.setData(this.detailData.listNotify[i]);
              }
            }
          }, 1000);
        }
      } else {
        this.detailData = null;
      }
    },
  },
  data() {
    return {
      templates: [],
      type: null,
      isUrgent: null,
      campType: null,
      endDate: new Date(),
      startDate: new Date(),

      detailData: null,
      detaiId: null,
      posRemoveTemplate: [],
      blur: false,
      urgentSelectData: [],
      requestTypeSelectData: [],
      dropListSelectData: [],
      indexAddTemplateBtn: 0,
      isLoading: false,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.form-control.error {
  border-color: red;
}

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}

.p-inline-30 {
  padding-inline: 30px !important;
}

.pyc-header {
  font-size: 25px;
  font-weight: bold;
}

.break-line {
  width: 100%;
  height: 1px;
  background: rgb(171, 171, 171);
  margin: 20px 0;
}

.title-id {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 20px;
}

.no-data {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: rgba(69, 69, 69, 0.702);
}

.fs-loading__cus {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #111;
  opacity: 0.7;
  z-index: 1000;
}

.fs-loading__cus::after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  border-left: 3px solid #e91c27;
  border-top: 3px solid #e91c27;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-animation: rotate360 1.5s infinite;
  animation: rotate360 1.5s infinite linear;
  z-index: 1000;
}

#loading-bg__cus {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: block;
  position: absolute;
  z-index: 99999;
}
</style>
